(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-simple"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-footer-scroll]');
    if (!button) return;

    const target = document.getElementById(button.dataset.footerScroll);
    if (!target) return;

    const headerHeight = document.getElementById('header-group')?.offsetHeight || 0;
    const offset = headerHeight + 32;
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY - offset,
      behavior: 'smooth',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-mini"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof Swiper !== 'undefined') {
      new Swiper('.slider-mini-swiper', {
        slidesPerView: 2.5,
        spaceBetween: 20,
        scrollbar: {
          el: '.slider-mini-swiper .swiper-scrollbar',
          draggable: true,
          dragSize: 'auto',
          snapOnRelease: true,
        },
        breakpoints: {
          640: { slidesPerView: 2.5 },
          768: { slidesPerView: 5 },
          1024: { slidesPerView: 8 },
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
